<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
      data() {
        return {
          items: [
            {
              image: "../pagesImages/muestra-1.jpg",
              video: "https://www.youtube.com/embed/RlBSrAyGa4o?si=V5KyeMTMtRMl8Miw",
            },
            {
              image: "../pagesImages/muestra-2.jpg",
              video: "https://www.youtube.com/embed/hIV691ryl90?si=zKuJJVpH74aQutHz",
            },
            {
              image: "../pagesImages/muestra-3.jpg",
              video: "https://www.youtube.com/embed/LkAyGgORQJo?si=ByCGvAHS5kdONKw5",
            },
            {
              image: "../pagesImages/muestra-4.jpg",
              video: "https://www.youtube.com/embed/6H8nKbdNVh8?si=ZPqaXU6Bxk9lsOYA",
            },
          ],
          showVideoIndex: -1,
        };
    },
    methods: {
      showVideo(index: number): void {
        this.showVideoIndex = index;
      },
    },
  });
  </script>

<template>
  <section class="grid lg:grid-cols-2 lg:mx-48 mx-4 lg:gap-4 gap-2 lg:mb-8 lg:mt-8 mb-2 mt-2">
    <div v-for="(item, index) in items" :key="index" class="relative group m-2 mb-4 border border-white">
      <img :src="item.image" alt="Image" class="w-full h-full object-cover cursor-pointer" @click="showVideo(index)" />
      <div v-if="showVideoIndex === index" class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-80">
        <iframe
          :src="item.video"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          style="width: 98%; height: 98%;"
        ></iframe>
      </div>
    </div>
  </section>
</template>
  
  